// Window Scroll Handler

(function ($) {
	$(window).on('scroll', function (e) {
		if ( !$(".header-logo-img").hasClass("scrunch") ) {
			if (window.scrollY > 90) {
				console.log("Start Scrunching.");
				$(".header-logo-img").addClass("scrunch");
			}
		}
		if (window.scrollY === 0) {
			console.log("Stop Scrunching");
			$(".header-logo-img").removeClass("scrunch");
		}
	});
})(jQuery);
